<px-o010-main-nav [menu]="_menu" [metaMenu]="_metaMenu" [downloadCenter]="_downloadCenter"></px-o010-main-nav>
